module.exports = __webpack_public_path__ + "static/media/bnr_rinec22a8f43339ad2b8ced2df9118d8dc7.webp";